module.controller('signupProgressCtrl', [
  'cardOrderService', 'localStorageService', '$state', '$http', 'baseURI',
  function(cardOrderService, localStorageService, $state, $http, baseURI) {

  var vm = this;
  var loadError = false;

  vm.cards = cardOrderService.getCards();
  vm.currentCard = cardOrderService.getCurrentCard();
  vm.loading = true;
  vm.loadError = false;
  vm.errorCode = false;
  vm.$state = $state;
  vm.showCard = showCard;
  vm.showLabel = showLabel;
  vm.editCard = editCard;
  vm.removeCard = removeCard;

  checkCurrentCard();
  loadCards();

  ///////////////////////////////

  function checkCurrentCard() {
    if (vm.currentCard === undefined) {
      vm.currentCard = localStorageService.get('cardOrderCurrentCard');
      if (vm.currentCard) {
        vm.cards.push(vm.currentCard);
      }
    }
  }

  function loadCards() {
    if ( $state.indexOf('signup.order') !== -1 ) {
      cardOrderService.loadCards().then(function(data) {
        vm.cards = data;
        vm.loading = false;
      }, function(error) {
        vm.loadError = true;
        vm.errorCode = error.data.ErrorCode;
        vm.loading = false;
      });
    } else {
      vm.loading = false;
    }
  }

  function showCard(index) {
    if ( vm.loadError ) {
      return false;
    } else if (vm.cards.length > 0) {
      var currentCardIndex = vm.cards.indexOf(vm.currentCard);
      if ( $state.indexOf('signup.order') !== -1 ) {
        return true; // Show all the cards in the last step
      } else if ( currentCardIndex === index ) {
        return true; // Show the current card only
      } else {
        return false;
      }
    }
  }

  function showLabel(index) {
    return false; // temporarily hide label
    // if ( $state.indexOf('signup.create') !== -1 || $state.indexOf('signup.customize') !== -1) {
    //   return true; // Always show the label in create and customize steps
    // } else if ( vm.cards[index].CardLabel ) {
    //   return true; // Show the label only if the user defined one
    // } else {
    //   return false;
    // }
  }

  function editCard(index) {
    cardOrderService.setCurrentCardIndex(index);
    $state.go('signup.create');
  }

  function removeCard(index) {
    vm.loading = true;
    var cardOrderItemId = vm.cards[index].CardOrderItemId;

    $http({
      url: baseURI + 'reloadable-card/order/' + cardOrderItemId,
      method: 'DELETE',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
    }).then(function (data, header){
      loadCards();
    }).catch(function (error){
      console.log(error);
    });
  }

}]);
